module.exports = __webpack_public_path__ + "img/01.c0804313.jpg";